import { createContext, useContext, useState, ReactNode } from 'react';

interface DataLoadingState {
  flows: boolean;
  departamentos: boolean;
  colaboradores: boolean;
  users: boolean;
  automacoes: boolean;
}

interface DataLoadingContextType {
  loadingStates: DataLoadingState;
  setLoadingState: (key: keyof DataLoadingState, value: boolean) => void;
  isAnyLoading: () => boolean;
}

const DataLoadingContext = createContext<DataLoadingContextType | undefined>(undefined);

export const DataLoadingProvider = ({ children }: { children: ReactNode }) => {
  const [loadingStates, setLoadingStates] = useState<DataLoadingState>({
    flows: false,
    departamentos: false,
    colaboradores: false,
    users: false,
    automacoes: false,
  });

  const setLoadingState = (key: keyof DataLoadingState, value: boolean) => {
    setLoadingStates(prev => ({ ...prev, [key]: value }));
  };

  const isAnyLoading = () => {
    return Object.values(loadingStates).some(state => state);
  };

  return (
    <DataLoadingContext.Provider value={{ loadingStates, setLoadingState, isAnyLoading }}>
      {children}
    </DataLoadingContext.Provider>
  );
};

export const useDataLoading = () => {
  const context = useContext(DataLoadingContext);
  if (!context) {
    throw new Error('useDataLoading must be used within a DataLoadingProvider');
  }
  return context;
};
